import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const steps = [
  {
    num: '01',
    title: 'AI пишет первым',
    description: 'Как только AIGAM находит горячий коммерческий запрос в Telegram-чатах, AI-рассыльщик автоматически инициирует диалог с потенциальным клиентом через ваш мессенджер.',
    icon: 'ri-send-plane-line',
  },
  {
    num: '02',
    title: 'Ведёт осмысленный диалог',
    description: 'AI понимает контекст запроса, задаёт уточняющие вопросы, рассказывает о вашем продукте и отвечает на возражения — как опытный менеджер по продажам.',
    icon: 'ri-chat-3-line',
  },
  {
    num: '03',
    title: 'Квалифицирует лида',
    description: 'В процессе диалога AI оценивает бюджет, срочность, полномочия и потребность клиента — вы получаете только квалифицированные заявки, готовые к сделке.',
    icon: 'ri-filter-3-line',
  },
  {
    num: '04',
    title: 'Передаёт в CRM',
    description: 'Готовый лид со всей историей переписки и результатами квалификации автоматически попадает в вашу CRM — менеджеру остаётся только закрыть сделку.',
    icon: 'ri-arrow-left-right-line',
  },
];

export default function ASHow() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 150 });
  const { containerRef: stepsRef, revealedCount: stepsRevealed } = useScrollRevealGroup<HTMLDivElement>(4);

  return (
    <section id="as-how" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16 max-w-[640px]">
          <span ref={labelRef} className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Как работает
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            AI-воронка:
            <br />
            от первого сообщения до сделки
          </h2>
        </div>

        <div ref={stepsRef} className="relative">
          {/* Вертикальная линия */}
          <div className="absolute left-[19px] md:left-[23px] top-4 bottom-4 w-px bg-background-200 hidden sm:block" />

          <div className="flex flex-col gap-10 md:gap-14">
            {steps.map((step, i) => (
              <div key={step.num} className={`flex gap-5 md:gap-8 reveal-fade-up ${i < stepsRevealed ? 'revealed' : ''}`} style={i < stepsRevealed ? { transitionDelay: `${i * 120}ms` } : undefined}>
                {/* Номер */}
                <div className="relative shrink-0">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-500 flex items-center justify-center">
                    <span className="text-sm md:text-base font-bold text-background-50">
                      {step.num}
                    </span>
                  </div>
                </div>

                {/* Контент */}
                <div className="pt-1 md:pt-2 flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="w-7 h-7 rounded-lg bg-primary-100 flex items-center justify-center text-primary-600">
                      <i className={`${step.icon} text-sm`}></i>
                    </span>
                    <h3 className="font-display font-bold text-[18px] text-foreground-950">
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-[14.5px] text-foreground-500 leading-relaxed max-w-[560px]">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}